import axios from "axios";
import { HR_BASE_URL } from "./appConst";

export const interviewRegister = async (values) => {

  const res = await axios.post(`${HR_BASE_URL}/webminer`, {
    name: values.name,
    email: values.email, 
    phone_number: values.phone_no,
    state: values.state,
    district: values.district,
    pin: values.pin,
    city: values.city,
    education_qualification: values.education_qualification,
    other_qualification: values.other_qualification,
    whatsapp_number: values.whatsapp_number,
  });

  return res;
};